import { render } from "./ErrorChangeAmount.vue?vue&type=template&id=4535fc8b&scoped=true"
import script from "./ErrorChangeAmount.vue?vue&type=script&lang=js"
export * from "./ErrorChangeAmount.vue?vue&type=script&lang=js"

import "./ErrorChangeAmount.vue?vue&type=style&index=0&id=4535fc8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4535fc8b"]])

export default __exports__